import { Button } from '@creditornot/cb-button';
import { colors, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Merchant } from 'apis/restaurant-api/merchant-admin/merchant/types';
import GuyMirror from 'common/illustrations/GuyMirror';
import { Typography as T } from 'common/typography';
import { localize } from 'common/utils';

type Props = {
  merchants: Merchant[];
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (width <= 640px) {
    gap: 16px;
  }
`;

const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  max-width: 600px;
  height: 106px;
  border-radius: 8px;
  background-color: ${colors.wolt8};
  padding-block: 16px;
  padding-inline: 16px;

  @media (width <= 640px) {
    height: 100%;
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
`;

const Content = styled.div`
  flex-grow: 1;
`;

const StyledHeading = styled(T.Heading6)`
  color: ${cbSemanticCssVars.textPrimary};
  font-size: 18px;
`;

const StyledBody = styled(T.Body3)`
  font-size: 14px;
  color: ${cbSemanticCssVars.textSecondary};
`;

const StyledButton = styled(Button)`
  width: 135px;
  height: 56px;
  flex-shrink: 0;

  @media (width <= 640px) {
    width: 100%;
    height: 36px;
  }
`;

const UnverifiedMerchants = ({ merchants }: Props) => {
  const history = useHistory();

  const intl = useIntl();

  return (
    <Root>
      {merchants.map(merchant => (
        <Card key={merchant.itemid.$oid}>
          <GuyMirror width={110} />
          <Content>
            <StyledHeading>
              <FormattedMessage id="compliance.kyb.awaiting-verification.heading" />
            </StyledHeading>
            <StyledBody>{localize(merchant.name, intl.locale)}</StyledBody>
          </Content>
          <StyledButton
            variant={'blue'}
            size={'small'}
            onClick={() => history.push(`/merchant/${merchant.itemid.$oid}/business-verification`)}
          >
            <FormattedMessage id="compliance.kyb.awaiting-verification.verify" />
          </StyledButton>
        </Card>
      ))}
    </Root>
  );
};

export default UnverifiedMerchants;
